import React from "react"
import styles from "./Header.module.scss"
import { FaChevronLeft, FaImages, FaUndo } from "react-icons/fa";
import { Link } from "@reach/router";
import characters from "../../characters";
import ProfileImage from "../widgets/ProfileImage";
import { connect } from "react-redux"

const Header = ({ storyName, ...props }) => {
  const profileImage = characters[storyName].profilePicture;
  const name = characters[storyName].name;

  return <div className={styles.header}>
    <Link to="/">
      <FaChevronLeft className={styles.icon}/>
    </Link>
    <span className={styles.profileContainer}>
        <ProfileImage image={profileImage}/>
      {name}
      <Link to={"/gallery/" + storyName}>
          <FaImages className={styles.icon}/>
        </Link>
      </span>
    <FaUndo className={styles.icon} onClick={() => {
      if (confirm("Do you want to start this story over?"))
        props.dispatch[storyName].restartStory();
    }}/>
  </div>
};

export default connect()(Header);
